import type { CoreApiClient } from "../client";
import { createAlarmMutations } from "../mutations/alarm.mutations";
import { createAlarmQueries } from "../queries/alarm.queries";

export const createAlarmRepository = (api: CoreApiClient) => ({
  ...createAlarmQueries(api),
  ...createAlarmMutations(api),
});
